module.exports = __webpack_public_path__ + "static/media/50.efd8f825.png";